import App from '../app'
import Vue from 'vue'
import VCardTotalSubjectsHomepage from '../../vue/components/VCardTotalSubjectsHomepage.vue'
import VCardTotalExecutionsHomepage from '../../vue/components/VCardTotalExecutionsHomepage.vue'
import VCardTotalEnforcedHomepage from '../../vue/components/VCardTotalEnforcedHomepage.vue'
import VCardTop3BiggestHomepage from '../../vue/components/VCardTop3BiggestHomepage.vue'
import VCardTop3LowestHomepage from '../../vue/components/VCardTop3LowestHomepage.vue'
import VCardAverageExecutionsHomepage from '../../vue/components/VCardAverageExecutionsHomepage.vue'
import VCardAverageAgeHomepage from '../../vue/components/VCardAverageAgeHomepage.vue'

new Vue({
  extends: App,
  components: {
    VCardTotalSubjectsHomepage,
    VCardTotalExecutionsHomepage,
    VCardTotalEnforcedHomepage,
    VCardTop3BiggestHomepage,
    VCardTop3LowestHomepage,
    VCardAverageExecutionsHomepage,
    VCardAverageAgeHomepage
  }
})
